import React from "react";
import Button from "./DefaultButton";

// Button component without forwardRef
const ToggleButton = ({ toggleState, setToggleState, className, noRounded, children, onClick, type, ...rest }) => {
  console.log("toggleState", children);
  return (
    <div className={`flex justify-start items-center w-fit bg-[#213b4d14] ${!noRounded ? "rounded" : ""} ${className}`}>
      <Button
        variant={toggleState ? "primary" : "secondary"}
        onClick={() => setToggleState(true)}
        className={`border-0 ${noRounded ? "!rounded-none" : ""} ${toggleState ? "" : "bg-transparent"}`}
      >
        {children[0]}
      </Button>

      <Button
        variant={toggleState ? "secondary" : "primary"}
        onClick={() => setToggleState(false)}
        className={`border-0 ${noRounded ? "!rounded-none" : ""} ${toggleState ? "bg-transparent" : ""}`}
      >
        {children[1]}
      </Button>
    </div>
  );
};

export default ToggleButton;
